import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import api from "../../utils/api";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import PublicIcon from "@mui/icons-material/Public";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import WebIcon from "@mui/icons-material/Web";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
const Project = ({ project }) => {
  // console.log("prject", project);
  const [uploader, setUploader] = useState("");
  useEffect(() => {
    // console.log("project user id", project?.userId);
    project?.userId &&
      api
        .get(`/user/getUserdataById/` + project?.userId)
        .then((res) => {
          console.log("user", res?.data);
          setUploader(res?.data);
        })
        .catch((err) => console.log("err", err));
  }, [project]);
  const userstate = useSelector((state) => state.loginUserReducer);
  const navigate = useNavigate();
  const { currentUser } = userstate;
  const [err, setErr] = useState("");
  const [projectComments, setProjectComments] = useState([]);
  const [commentCount, setCommentCount] = useState(0);
  const [showComments, setShowComments] = useState(false);
  const [comment, setComment] = useState("");
  const submitComment = (id) => {
    console.log("comment", comment);
    if (comment.length > 10) {
      const body = {
        userId: currentUser?.id,
        projectId: project?._id,
        comment: comment,
        user: currentUser,
      };
      api
        .post("/projects/submit-comment", body)
        .then((res) => {
          console.log("res>", res.data);
          window.location.reload();
        })
        .catch((err) => console.log(err));
      setComment("");
    } else {
      setErr("your comment is too short");
    }
  };
  useEffect(() => {
    api
      .get(`/projects/comments/${project?._id}`)
      .then((res) => {
        // console.log("project comments", res.data);
        if (res.data.length > 0) {
          setProjectComments(res.data);
          setCommentCount(res.data.length);
        }
      })
      .catch((err) => console.log);
  }, []);
  const deleteProject = (p) => {
    api
      .delete(`/projects/${p?._id}`)
      .then((res) => {
        if (res.data) {
          let notifBody = {
            userId: currentUser?.id,
            text: `Admin delete your project for violating terms and conditions.`,
            forAll: false,
            receiverId: p?.userId,
          };
          api
            .post("/notifications", notifBody)
            .then((re) => console.log("notif", re.data));
          window.location.reload();
        }
      })
      .catch((err) => console.log);
  };
  return (
    <Card sx={{ width: "100%" }}>
      <CardHeader
        onClick={() => navigate(`/user-profile/${project?.userId}`)}
        className="title__link"
        avatar={
          <Stack direction="column">
            {uploader?.profile ? (
              <Avatar
                src={uploader?.profile}
                alt={uploader?.name?.at(0)?.toUpperCase()}
              />
            ) : (
              <Avatar sx={{ bgcolor: "colorThree.main" }} aria-label="recipe">
                {uploader?.name?.at(0)?.toUpperCase()}
              </Avatar>
            )}
          </Stack>
        }
        // action={
        //   <IconButton aria-label="settings">
        //     <MoreVertIcon />
        //   </IconButton>
        // }
        title={uploader?.name?.toUpperCase()}
        subheader={new Date(project?.createdAt).toDateString()}
      />
      {/* {hostel?.hostelImage && (
        <CardMedia
          component="img"
          height="50"
          width="50"
          image={hostel?.hostelImage}
          alt="Paella dish"
        />
      )} */}

      <CardContent sx={{ marginTop: "-20px" }}>
        <Box
          sx={{
            boxShadow: "none",
            padding: "20px 0",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              textTransform: "whitesmoke",
              fontWeight: "600",
              cursor: "pointer",
            }}
            className="title__link"
            onClick={() => navigate(`/project-details/${project?._id}`)}
          >
            {project?.title}
          </Typography>
          <Box
            container
            sx={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "flex-start",
              gap: "5vw",
            }}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "80%", sm: "45% 45%" },
                width: "100%",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {" "}
                <Typography
                  variant="body2"
                  sx={{
                    width: "120px",
                    fontWeight: "600",
                    color: "#777",
                  }}
                >
                  <PublicIcon sx={{ color: "gray", marginRight: "5px" }} />
                  Technology
                </Typography>
                <Typography variant="body2">{project?.tech_used}</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {" "}
                <Typography
                  variant="body2"
                  sx={{
                    width: "120px",
                    fontWeight: "600",
                    color: "#777",
                  }}
                >
                  <AttachMoneyIcon sx={{ color: "gray", marginRight: "5px" }} />
                  Price
                </Typography>
                <Typography variant="body2">{project?.price}</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {" "}
                <Typography
                  variant="body2"
                  sx={{
                    width: "120px",
                    fontWeight: "600",
                    color: "#777",
                  }}
                >
                  <WebIcon sx={{ color: "gray", marginRight: "5px" }} />
                  Type
                </Typography>
                <Typography variant="body2">{project?.projectType}</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {" "}
                <Typography
                  variant="body2"
                  sx={{
                    width: "120px",
                    fontWeight: "600",
                    color: "#777",
                  }}
                >
                  <HourglassTopIcon
                    sx={{ color: "gray", marginRight: "5px" }}
                  />
                  Deadline
                </Typography>
                <Typography variant="body2"> {project?.deadline}</Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: "20px",
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <Typography variant="p" sx={{ fontWeight: "600" }}>
              Required Skills
            </Typography>
            <Box sx={{ display: "flex" }}>
              {project?.skills?.map((f) => (
                <Typography
                  variant="body2"
                  sx={{
                    border: "1px solid lightgray",
                    width: "max-content",
                    padding: "2px 4px",
                    margin: "3px",
                    color: "colorThree.main",
                  }}
                >
                  {f}
                </Typography>
              ))}
            </Box>
          </Box>
          {project?.description && (
            <Box sx={{ marginTop: "20px" }}>
              <Typography
                className="ellipsis__two__lines title__link"
                variant="body2"
                onClick={() => navigate(`/project-details/${project?._id}`)}
              >
                {project?.description}
              </Typography>
            </Box>
          )}
        </Box>
        {/* <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            style={{
              marginLeft: "auto",
              marginTop: "10px",
              textDecoration: "underline",
            }}
            className=""
            onClick={() => navigate(`/project-details/${project?._id}`)}
          >
            details
          </button>
        </Box> */}
        {/* <Typography
          sx={{
            fontSize: "1.5rem",
            marginBottom: "10px",
            fontWeight: "500",
            textTransform: "capitalize",
          }}
          color="fontPrimaryColor.main"
          className="question__title"
          // onClick={() => navigate(`/answers/${question._id}`)}
        >
          {project?.title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {project?.description}
        </Typography>
        {project?.projectImage && (
          <img
            style={{
              margin: "20px 0",
              marginLeft: "50%",
              transform: "translateX(-50%)",
            }}
            height="auto"
            width="60%"
            src={project?.projectImage}
            alt="Paella dish"
          />
        )}
        <Box className="language mt-4 bg-white">
          <Box className="tags bg-white">
            {project?.tags?.map((t) => (
              <Typography className="tag-span">{t}</Typography>
            ))}
          </Box>
        </Box>

        <Box className="country mt-4 mb-1">
          <Typography variant="body2" sx={{ fontWeight: "600" }}>
            Price
          </Typography>
          <Typography variant="body2">{project?.price} PKR</Typography>
        </Box>
        <Box className="duration mb-1">
          <Typography variant="body2" sx={{ fontWeight: "600" }}>
            Deadline
          </Typography>
          <Typography>{project?.deadline} </Typography>
        </Box>
        <Box className="duration mb-1">
          <Typography variant="body2" sx={{ fontWeight: "600" }}>
            Project Type
          </Typography>
          <Typography>{project?.projectType} </Typography>
        </Box>
        <Box className="amount mb-4 mb-1">
          <Typography variant="body2" sx={{ fontWeight: "600" }}>
            Technology used
          </Typography>
          <Typography>
            {project?.tech_used ? project?.tech_used : "null"}
          </Typography>
        </Box> */}

        {/* <Box className="desc">
          <p>{hostel?.description ? hostel?.description : "no description"}</p>
        </Box> */}
        {/************= */}
        <div className="col-lg-6 col-12 row mt-4">
          {/* <h6 className="mb-1 mt-3"> Comments ({commentCount}) </h6>
          <span
            className="underline inline mb-3 pointer"
            onClick={() => setShowComments(!showComments)}
          >
            {" "}
            {!showComments ? "show" : "hide"}
          </span>

          {showComments && (
            <>
              {projectComments.length > 0 ? (
                projectComments.map((comment) => (
                  <div className="show-comments mt-0 mb-0">
                    <p>
                      <strong>{comment?.user.name}</strong>
                    </p>
                    <p>{comment?.comment}</p>
                    <br />
                  </div>
                ))
              ) : (
                <p>no comments</p>
              )}
            </>
          )} */}
        </div>
        {currentUser?.isAdmin ? (
          <button
            className=" asc__submit__form__button"
            onClick={() => deleteProject(project)}
          >
            Delete Project
          </button>
        ) : (
          <div className="comments row">
            {/* <Typography
              variant="body2"
              sx={{ fontWeight: "600" }}
              className="my-3"
            >
              Comment:
            </Typography>
            <div className="col-lg-6 col-12">
              <textarea
                placeholder="Comment"
                className="border border-dark rounded text-area w-full input__field__asc"
                onChange={(e) => setComment(e.target.value)}
              ></textarea>
              {err && <p className="error__para">{err}</p>}
              <button
                className=" asc__submit__form__button"
                onClick={(e) => submitComment(e)}
              >
                Submit
              </button>
            </div> */}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default Project;
